<template>
    <div class="">
        <div>
            <div>
                <div class="detail_bgColor">
                    <div class="inner">
                        <div>
                            <div class="productdetail_type">{{$t('common.home')}}>{{$t('common.chanpin')}}><span> {{productdetail.prdName}}</span> </div>
                            <div class="display_flex ">
                                <div>
                                    <div class="productImage" :style="{backgroundImage: 'url(' + productdetail.image + ')'}" @click="showBigImg(productdetail.bigimage)">
                                       
                                        <!-- <pic-zoom :url="productdetail.image"  :scale="3"></pic-zoom> -->
                                    </div>
                                    
                                </div>
                                <div class="product_detail_contain">
                                    <div class="product_subtitle">{{productdetail.prdName}}</div>
                                    <div class="textalign_left padding__top_8">
                                       <!--  <span class="product_tips" v-if="productdetail.tag" v-for="item in splitfun(productdetail.tag)">{{item}}</span> -->
                                        <span class="product_tips" v-if="Number(productdetail.fishclass) == 10">{{$t('product.greenproduct')}}</span>
                                        <span class="product_effency_tips" v-if="productdetail.efficacy && productdetail.efficacy.length > 0">{{$t('product.effecy_xianzhu')}}</span>
                                        
                                    </div>
                                    <!--  -->
                                    <div class="product_parameter">
                                        <div class="display_flex justify-content_flex-justify" style="margin-bottom: 24px;">
                                            <div class="product_parameter_item">
                                                <span class="product_parameter_name">{{$t('product.address')}}</span><span class="product_parameter_conent">
                                                    {{productdetail.originplace}}
                                                </span>
                                            </div>
                                            <div class="product_parameter_item">
                                                <span class="product_parameter_name">{{$t('product.UCP')}}</span><span class="product_parameter_conent">{{productdetail.upc}}</span>
                                            </div>
                                            
                                        </div>
                                        <div class="display_flex justify-content_flex-justify">
                                            <div class="product_parameter_item">
                                                <span class="product_parameter_name">{{$t('product.price')}}</span><span class="product_parameter_conent">
                                                    {{productdetail.price}}{{productdetail.currency}}
                                                </span>
                                            </div>
                                            <div class="product_parameter_item">
                                                <span class="product_parameter_name">{{$t('product.size')}}</span><span class="product_parameter_conent">{{productdetail.size}}</span>
                                            </div>
                                            
                                        </div>
                                    </div>
                                    <div style="padding-bottom: 10px;box-sizing: border-box;">
                                        <div  v-if="Number(productdetail.fishclass) == 10"  style="display: inline-block;z-index: 1;">
                                            <img :src="labelarr['green']" class="efficacyimg">
                                        </div>
                                        <div v-for="(item,index) in effencyTopIcon(productdetail.efficacy)" style="display: inline-block;" :style="{zIndex:index+2}" :class="['margin_left_16',(productdetail.fishclass !== '10' && index ==0) ?'active':'']">
                                            <img :src="item.chs_image" class="efficacyimg" v-if="currentlang == 'chs'">
                                            <img :src="item.cht_image" class="efficacyimg" v-if="currentlang == 'cht'">
                                            <img :src="item.eng_image" class="efficacyimg" v-if="currentlang == 'eng'">
                                        </div>
                                    </div>
                                  
                                    
                                    
                                </div>
                            </div>
                        </div>
                        <div class="ingredient_reportcontian">
                            <div class="title_box" v-if="currentlang !== 'eng' && productdetail.ingredientTotal!=null">
                                <div class="display_flex justify-content_flex-justify align-items_center" style="padding-bottom: 24px;box-sizing:border-box;">
                                    <div class="report_subtitle">{{$t('product.ingredient')}}</div>
                                    <div class="title_right" @click="checkIngredient({})"><span class="vertical-middle">查看全部 {{productdetail.ingredientTotal}} 种成分</span><img src="https://p1.fishqc.net/FlSmwa7dN1JmQucjATcL-CrpTzp6" class="vertical-middle" style="width: 14px"></div>
                                 </div>
                                <div class="title_line"></div>

                            </div>
                                
                           <div v-if="compositiondata.length >0" style="border-bottom:2px solid #F4F4F5;padding-bottom: 32px;box-sizing: border-box;">
                                <div class="testresult padding_bottom_6" v-if="compositiondata.length">{{$t('product.effency_cankao')}}</div>
                                <div class="display_flex effency_margin " v-for="item in compositiondata" @click="checkIngredient(item)">
                                    <div class="effency_desc_first cursor">{{item.name}}</div>
                                    <div class="effency_height cursor" :style="{width:item.num * 40+'px'}"></div>
                                    <div class="effency_cankao cursor">{{item.num}}种</div>
                                </div>
                            </div>
                        </div>
                        <div class="display_flex justify-content_flex-justify" v-if="false">
                            <div class="reportcontian" >
                                <div v-if="productdetail.fishclass == '10'">
                                    <div class="title_box">
                                        <div class="report_subtitle">{{$t('common.title')}}</div>
                                        <div class="title_line" ></div>
                                    </div>
                                    <div class="display_flex justify-content_flex-justify padding_top_26">
                                        <div class="product_detail_effectdetail display_flex justify-content_flex-center align-items_center flex-wrap_wrap">
                                            <div class="width-100">
                                                <img :src="effectdetail['eeq'].icon" class="img1">
                                                <div class="product_detail_effecttxt">
                                                    <div class="product_detail_effecttxtbg"></div>
                                                    <span class="effectresult">{{effectdetail['eeq'].result}}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="product_detail_effectdetail display_flex justify-content_flex-center align-items_center flex-wrap_wrap">
                                            <div class="width-100">
                                                <img :src="effectdetail['at'].icon" class="img1">
                                                <div class="product_detail_effecttxt">
                                                    <div class="product_detail_effecttxtbg"></div>
                                                    <span class="effectresult">{{effectdetail['at'].result}}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="product_detail_effectdetail display_flex justify-content_flex-center align-items_center flex-wrap_wrap">
                                            <div class="width-100">
                                                <img :src="effectdetail['pass'].icon" class="img1">
                                                <div class="product_detail_effecttxt">
                                                    <div class="product_detail_effecttxtbg"></div>
                                                    <span class="effectresult">{{effectdetail['pass'].result}}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                
                                    <div class="productdetail_test">
                                        {{$t('product.Testing')}}
                                    </div>
                                    <div class="productdetail_test1">
                                        <div class="productdetail_test_desc">{{effectdetail['eeq'].title}}</div>
                                        <div class="productdetail_test_desc1">{{effectdetail['eeq'].desc}}</div>
                                        <div class="padding_top_16 display_flex">
                                            <div class="product_img" :style="{backgroundImage: 'url(' + productdetail.image + ')'}"></div>
                                            <div class="display_flex flex-wrap_wrap padding_right_30">
                                                <div class="margin_top_12">
                                                    <img src="http://p1.fishqc.net/FgixgSZuwESI2RrPrrNIEwJKWkN2">
                                                </div>
                                                <div class="padding_14_10">
                                                    <img :src="effectdetail['eeq'].statusicon">
                                                </div>
                                                <div>
                                                    <img src="http://p1.fishqc.net/FlHmaPygsl7ebUlbkvV_3sG-jh9U">
                                                </div>
                                            </div>
                                            <div class="textalign_center">
                                                <img :src="effectdetail['eeq'].icon">
                                                <div class="productdetail_test_result">{{$t('product.result_good')}}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="productdetail_test1">
                                        <div class="productdetail_test_desc">{{effectdetail['at'].title}}</div>
                                        <div class="productdetail_test_desc1">{{effectdetail['at'].desc}}</div>
                                        <div class="padding_top_16 display_flex">
                                            <div class="product_img" :style="{backgroundImage: 'url(' + productdetail.image + ')'}"></div>
                                            <div class="display_flex flex-wrap_wrap padding_right_30">
                                                <div class="margin_top_12">
                                                    <img src="http://p1.fishqc.net/FgixgSZuwESI2RrPrrNIEwJKWkN2">
                                                </div>
                                                <div class="padding_14_10">
                                                    <img :src="effectdetail['at'].statusicon">
                                                </div>
                                                <div>
                                                    <img src="http://p1.fishqc.net/FlHmaPygsl7ebUlbkvV_3sG-jh9U">
                                                </div>
                                            </div>
                                            <div class="textalign_center">
                                                <img :src="effectdetail['at'].icon">
                                                <div class="productdetail_test_result">{{$t('product.result_good')}}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="productdetail_test1">
                                        <div class="productdetail_test_desc">{{effectdetail['pass'].title}}</div>
                                        <div class="productdetail_test_desc1">{{effectdetail['pass'].desc}}</div>
                                        <div class="padding_top_16 display_flex">
                                            <div class="product_img" :style="{backgroundImage: 'url(' + productdetail.image + ')'}"></div>
                                            <div class="display_flex flex-wrap_wrap padding_right_30">
                                                <div class="margin_top_12">
                                                    <img src="http://p1.fishqc.net/FgixgSZuwESI2RrPrrNIEwJKWkN2">
                                                </div>
                                                <div class="padding_14_10">
                                                    <img :src="effectdetail['pass'].statusicon">
                                                </div>
                                                <div>
                                                    <img src="http://p1.fishqc.net/FlHmaPygsl7ebUlbkvV_3sG-jh9U">
                                                </div>
                                            </div>
                                            <div class="textalign_center">
                                                <img :src="effectdetail['pass'].icon">
                                                <div class="productdetail_test_result">{{$t('product.result_good')}}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="productdetail.efficacy && productdetail.efficacy.length > 0">
                                    <div class="title_box">
                                        <div class="report_subtitle">{{$t('product.effency_desc1')}}</div>
                                        <div class="title_line"></div>
                                    </div>
                                    <div class="effect_detail">
                                        <span>{{$t('product.effency_desc2')}}</span><span class="color1">{{productdetail.efficacy.length}}</span><span>{{$t('product.effency_desc3')}}</span>
                                    </div>
                                    <div style="position: relative;background-color: #F8FBFD;padding-top: 50px;">
                                        <div class="effecttype">{{$t('product.effecy_xianzhu')}}</div>
                                        <div class="effect_item display_flex justify-content_flex-justify" v-for="item in productdetail.efficacy">
                                            <div style="padding-top:30px;">
                                                <img v-if="currentlang == 'chs'" :src="item.chs_image" style="width: 120px;height: 120px;">
                                                <img v-if="currentlang == 'cht'" :src="item.cht_image" style="width: 120px;height: 120px;">
                                                <img v-if="currentlang == 'eng'" :src="item.eng_image" style="width: 120px;height: 120px;">
                                            </div>
                                            <div class="" style="padding:6px 0 30px;box-sizing:border-box;">
                                               
                                                <div  style="padding:24px 0 0 20px;box-sizing:border-box;">
                                                    <div v-if="currentlang == 'chs'">
                                                        <div class="effecttitle" >{{item.chs_name}}</div>
                                                        <div class="effextdesc" >{{item.chs_desc}}</div>
                                                    </div>
                                                    <div v-if="currentlang == 'cht'">
                                                        <div class="effecttitle" >{{item.cht_name}}</div>
                                                        <div class="effextdesc" >{{item.cht_desc}}</div>
                                                    </div>
                                                    <div v-if="currentlang == 'eng'">
                                                        <div class="effecttitle" >{{item.eng_name}}</div>
                                                        <div class="effextdesc" >{{item.eng_desc}}</div>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                        </div>
                                    </div>
                                    
                                </div>
                                <div v-if="false">
                                    <div class="title_box">
                                        <div class="report_subtitle">体验总评</div>
                                        <div class="title_line"></div>
                                    </div>
                                    <div class="display_flex justify-content_flex-justify try_padding_top_30">
                                        <div class="product_try_totaldesc">
                                            <!-- <star starsize="24" :score.sync=""></star> -->
                                            <star starsize="24" :score.sync="productTryReportdata.totalscore"></star>
                                            <!-- <img class="vertical-middle try_star" width="24px" height="24px" src="http://p1.fishqc.net/Fp9eguTZNaC4YjZVpjYvLcgo18xW" v-for="item in 5"> -->
                                            <span class="vertical-middle "> 完美啊！</span>
                                        </div>
                                        <div class="product_try_totalnum">{{productTryReportdata.reporttotal}}条用户体验报告 ></div>
                                    </div>
                                    <div>共{{productTryReportdata.reporttotal}}条</div>
                                    <div class="paddding_top_10">
                                        <span class="try_tips" v-for='item in 4'>完美啊 (110)</span>
                                    </div>
                                    <div class="try_box">
                                        <div class="display_flex flex-wrap_wrap">
                                            <div class="try_commentImg"></div>
                                            <div class="display_flex justify-content_flex-justify flex-direction_column">
                                                <div class="nickname">90后辣妈</div>
                                                <div class="suggest">试后推荐度：</div>
                                            </div>
                                        </div>
                                        <div class="padding_left_90">
                                            <div class="title">保湿度杠杠的！</div>
                                            <div v-for="item in 3">
                                                <div class="content_suggest_box display_flex  flex-wrap_wrap align-items_center" >
                                                    <span class="content_question">产品的清爽度怎样？</span>
                                                    <img src="http://p1.fishqc.net/Fp9eguTZNaC4YjZVpjYvLcgo18xW" alt="" v-for="item in  5" style="width:16px;height:16px;margin-right:6px;">
                                                    <span >很满意 推荐</span>
                                                </div>
                                                <div class="content">奶油质地，易推开不厚重，满足我的基本需求，滋润不油腻，保湿度非常好， 干皮油皮敏感肌都可以使用，香味很淡，却很好闻，唯一一个缺点可能就是一瓶的量感觉好少。奶油质地，易推开不厚重，满足我的基本需求，滋润不油腻，保湿度非常好， 干皮油皮敏感肌都可以使用，香味很淡，却很好闻，唯一一个缺点可能就是一瓶的量感觉好少。</div>
                                                <div class="maxwidth">
                                                    <div class="contentImg" v-for="item in 5"></div>
                                                </div>
                                            </div>
                                            <div class="display_flex justify-content_flex-justify contentdetail">
                                                <div>1小时前</div>
                                                <div>
                                                    <span class="padding_right_20">点赞 223</span><span>收藏 220</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- <div class="title_box" v-if="currentlang !== 'eng' && productdetail.ingredientTotal!=null">
                                    <div class="display_flex justify-content_flex-justify align-items_center">
                                        <div class="report_subtitle">{{$t('product.ingredient')}}</div>
                                        <div class="title_right" @click="checkIngredient({})">查看全部 {{productdetail.ingredientTotal}} 种成分</div>
                                     </div>
                                    <div class="title_line"></div>

                                </div>
                                    
                               
                                <div class="testresult padding_bottom_6" v-if="compositiondata.length">{{$t('product.effency_cankao')}}</div>
                                <div class="display_flex effency_margin " v-for="item in compositiondata" @click="checkIngredient(item)">
                                    <div class="effency_desc_first cursor">{{item.name}}</div>
                                    <div class="effency_height cursor" :style="{width:item.num * 40+'px'}"></div>
                                    <div class="effency_cankao cursor">{{item.num}}种</div>
                                </div> -->
                                <!-- <div class="testresult padding_bottom_6" v-if="securitydata.length > 0">风险参考</div>
                                <div class="display_flex effency_margin" v-for="item in securitydata">
                                    <div class="effency_desc_first">{{item.name}}</div>
                                    <div class="effency_height" :style="{width:item.num * 40+'px'}"></div>
                                    <div class="effency_cankao">{{item.num}}种</div>
                                </div> -->

                                
                                
                               
                            </div>
                           
                        </div>
                    </div>
                </div>
                <!-- 测试 -->
                <div class="detail_bgColor" style="padding-bottom: 64px;box-sizing: border-box;" v-if="Number(productdetail.attPass)|| Number(productdetail.eeqPass) || Number(productdetail.ingPass)">
                    <div class="inner">
                        <div class="detail_introduct_title">{{$t('product.Testing')}}</div>
                        <div class="green_bg" v-if="Number(productdetail.fishclass) == 10">
                            <div class="display_flex greenbg_content">
                                <div class="bgcolor display_flex align-items_center">
                                    <div class="padding_left24"> 
                                        <div class="greenfish_title" :class="{engsize:currentlang == 'eng'}">{{$t('about.green_excellent')}}</div>
                                        <div class="greenfish_desc1" :class="{engsize:currentlang == 'eng'}">{{$t('about.greensuggest1')}}</div>
                                        <div class="greenfish_desc2" :class="{engsize:currentlang == 'eng'}" v-html="$t('about.greendesc')"></div>
                                    </div>
                                    
                                </div>
                                <div class="left0"> 
                                    <img :src="labelarr['green']" alt="" class="greenicon">
                                </div>
                            </div>
                            
                        </div>
                        <div class="display_flex align-items_center" style="background: #fff;padding:0 0 0 64px;box-sizing: border-box;margin-bottom: 24px;height: 286px;" v-if="Number(productdetail.attPass)">
                            <div style="padding-right: 32px;box-sizing: border-box;">
                                <div class="detail_introduct_productImg" :style="{backgroundImage: 'url(' + productdetail.image + ')'}"></div>
                            </div>
                            <div class="display_flex align-items_center">
                                <img src="https://p1.fishqc.net/FoACiY4hTAq36LROcPBzWC5I4hCc">
                                <img src="https://p1.fishqc.net/FmuvdDRC7UYRguA0G98-59LUL4QS" style="margin:0 28px;box-sizing: border-box;width: 180px;height: 180px;">
                                <img src="https://p1.fishqc.net/FoACiY4hTAq36LROcPBzWC5I4hCc">
                            </div>
                            <div style="padding-left: 48px;box-sizing: border-box;">
                                <div>
                                    <img src="https://p1.fishqc.net/FuZRfhVOP8MSIoO1DC0XtdpPa7pQ" alt="">
                                </div>
                                <div class="detail_introduct_productdesc">{{$t('product.result_good')}}</div>
                            </div>
                            <div style="padding-left: 156px;box-sizing: border-box;">
                                <div class="detail_introduct_effencytitle">{{effectdetail['at'].title}}</div>
                                <div class="detail_introduct_effencydesc">{{effectdetail['at'].desc}}</div>
                            </div>
                        </div>
                        <div class="display_flex align-items_center" style="background: #fff;padding:0 0 0 64px;box-sizing: border-box;margin-bottom: 24px;height: 286px;" v-if="Number(productdetail.eeqPass)">
                            <div style="padding-right: 32px;box-sizing: border-box;">
                                <div class="detail_introduct_productImg" :style="{backgroundImage: 'url(' + productdetail.image + ')'}"></div>
                            </div>
                            
                            <div class="display_flex align-items_center">
                                <img src="https://p1.fishqc.net/FoACiY4hTAq36LROcPBzWC5I4hCc">
                                <img src="https://p1.fishqc.net/FtGY-Q-xjGOfMhtwt78B9Fzl-TF7" style="margin:0 28px;box-sizing: border-box;width: 180px;height: 180px;">
                                <img src="https://p1.fishqc.net/FoACiY4hTAq36LROcPBzWC5I4hCc">
                            </div>
                            <div style="padding-left: 48px;box-sizing: border-box;">
                                <div>
                                    <img src="https://p1.fishqc.net/FixzIVgo7q3oG_Maj8SQtHHac3js" alt="">
                                </div>
                                <div class="detail_introduct_productdesc" style="color: #3AD6A2;">{{$t('product.result_good')}}</div>
                            </div>
                            <div style="padding-left: 156px;box-sizing: border-box;">
                                <div class="detail_introduct_effencytitle">{{effectdetail['eeq'].title}}</div>
                                <div class="detail_introduct_effencydesc">{{effectdetail['eeq'].desc}}</div>
                            </div>
                        </div>
                        <div class="display_flex align-items_center" style="background: #fff;padding:0 0 0 64px;box-sizing: border-box;margin-bottom: 24px;height: 286px;" v-if="Number(productdetail.ingPass)">
                            <div style="padding-right: 32px;box-sizing: border-box;">
                                <div class="detail_introduct_productImg" :style="{backgroundImage: 'url(' + productdetail.image + ')'}"></div>
                            </div>
                            
                            <div class="display_flex align-items_center">
                                <img src="https://p1.fishqc.net/FoACiY4hTAq36LROcPBzWC5I4hCc">
                                <img src="https://p1.fishqc.net/FtcdakxGA_7j02YaIy0KGzfuW6i2" style="margin:0 28px;box-sizing: border-box;width: 180px;height: 180px;">
                                <img src="https://p1.fishqc.net/FoACiY4hTAq36LROcPBzWC5I4hCc">
                            </div>
                            <div style="padding-left: 48px;box-sizing: border-box;">
                                <div>
                                    <img src="https://p1.fishqc.net/FrDqf0i7KHaFdRr2KoFWFjgaEMMU" alt="">
                                </div>
                                <div class="detail_introduct_productdesc" style="color: #3AC7CE;">{{$t('product.result_good')}}</div>
                            </div>
                            <div style="padding-left: 156px;box-sizing: border-box;">
                                <div class="detail_introduct_effencytitle">{{effectdetail['pass'].title}}</div>
                                <div class="detail_introduct_effencydesc">{{effectdetail['pass'].desc}}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <!--  -->
                <div class="detail_bgColor" v-if="productdetail.efficacy.length">
                    <div class="inner">
                        <div class="detail_effency_title">{{$t('product.effency_desc1')}}</div>
                        <div class="detail_effency_xiang"><span>{{$t('product.effency_desc2')}}</span> <span class="color1">{{productdetail.efficacy.length}}</span> <span>{{$t('product.effency_desc3')}}</span></div>
                        <div style="padding-bottom: 72px;">
                            <div class="display_flex" v-for="item in productdetail.efficacy" style="padding-bottom: 12px;box-sizing: border-box;border-bottom: 1px solid #F4F4F5;margin-bottom: 36px;">
                                <div class="detail_effency_Image">
                                    <div class="bg"></div>
                                    <img v-if="currentlang == 'chs'" :src="item.chs_image" style="width: 120px;height: 120px;left: -12px;top: -12px;position:absolute;">
                                    <img v-if="currentlang == 'cht'" :src="item.cht_image" style="width: 120px;height: 120px;left: -12px;top: -12px;position:absolute;">
                                    <img v-if="currentlang == 'eng'" :src="item.eng_image" style="width: 120px;height: 120px;left: -12px;top: -12px;position:absolute;">
                                </div>
                                <div class="flex_1">
                                    <div v-if="currentlang == 'chs'">
                                        <div class="detail_effency_effecttitle" >{{item.chs_name}}</div>
                                        <div class="detail_effency_effextdesc" >{{item.chs_desc}}</div>
                                    </div>
                                    <div v-if="currentlang == 'cht'">
                                        <div class="detail_effency_effecttitle" >{{item.cht_name}}</div>
                                        <div class="detail_effency_effextdesc" >{{item.cht_desc}}</div>
                                    </div>
                                    <div v-if="currentlang == 'eng'">
                                        <div class="detail_effency_effecttitle" >{{item.eng_name}}</div>
                                        <div class="detail_effency_effextdesc" >{{item.eng_desc}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!--  -->
                
            </div>
        </div>
        <modal ref="modaltoast" @modalthings="getmaterial"></modal>
    </div>
</template>
<style lang="scss" scoped>
@import "@/assets/css/mixin.scss";

.margin_top_100 {
    margin-top: 100px;
}

.margin_top_32 {
    margin-top: 32px;
    box-shadow: 0;
}

.padding-32 {
    padding: 32px 0;
    box-sizing: border-box;
}

.padding-bottom-16 {
    padding: 0px 0 16px;
    box-sizing: border-box;
}

.content_bottom_L {
    display: inline-block;

    .date {
        padding-left: 6px;
        box-sizing: border-box;
        color: #888888
    }
}

.content_bottom_R {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 12px;
    display: inline-block;
    padding: 6px 16px;
    box-sizing: border-box;
    background: linear-gradient(270deg, #28D877 0%, #0DC6B8 100%);
    border-radius: 0px 12px 12px 12px;

}

.reportmenu {
    width: 384px;
    max-height: 500px;
    padding: 0 32px 34px;
    box-sizing: border-box;
    background: #FFFFFF;
    border: 1px solid #F4F4F5;
    text-align: left;

    &.boxshadow {
        box-shadow: 0 10px 30px 0 rgba(233, 233, 235, 0.3);
    }

    .title {
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 24px;
        padding: 26px 0 16px;
        box-sizing: border-box;
        border-bottom: 1px solid #E5E5E5;
    }

    .title_list {
        margin-top: 16px;
        box-sizing: border-box;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #51515C;
        line-height: 24px;
        position: relative;
        padding-left: 16px;
        cursor: pointer;

        &:hover {
            color: #60DEB4;
        }

        &:before {
            content: '';
            position: absolute;
            left: 0%;
            top: 50%;
            transform: translate(0, -50%);
            width: 8px;
            height: 8px;
            background: #60DEB4;
            border-radius: 56px;

        }

        .active {
            color: #60DEB4;
        }
    }

    .nextreport_title {
        padding-top: 16px;
        padding-bottom: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333342;
        line-height: 24px;
    }
}

.padding_16 {
    padding: 16px 0;
    box-sizing: border-box;
}

.reportcontian {
    width: 792px;
    text-align: left;

    .report_title {
        font-size: 32px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        line-height: 48px;
    }

    .report_collect {
        display: inline-block;
        width: 64px;
        height: 24px;
        line-height: 24px;
        background: #60DEB4;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        letter-spacing: 3px;
        text-align: center;
    }

    .report_time {
        line-height: 24px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #888888;
        padding-right: 30px;
        box-sizing: border-box;
    }

    .report_desc {
        font-size: 16px;
        font-family: PingFang-SC-Regular, PingFang-SC;
        font-weight: 400;
        color: #51515C;
        line-height: 28px;
        text-align: justify;
    }

    .report_subtitle {
        font-size: 28px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #262633;
        line-height: 32px;
        padding-bottom: 18px;
        display: inline-block;

        padding-left: 2px;
        box-sizing: border-box;

    }

    .title_box {
        padding-top: 32px;
        box-sizing: border-box;

        .title_line {
            margin-top: -2px;
            height: 2px;
            background: #F4F4F5;
            position: relative;

            &:before {
                width: 120px;
                height: 4px;
                background: #60DEB4;
                content: '';
                position: absolute;
                left: 0;
                top: -1px;
            }
        }

        .title_right{
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #60DEB4;
            line-height: 16px;
            cursor: pointer;
        }
    }

    .testresult {
        padding: 16px 0 16px 16px;
        box-sizing: border-box;
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #262633;
        line-height: 32px;
        position: relative;

        &:before {
            content: '';
            position: absolute;
            left: 0%;
            top: 50%;
            transform: translate(0, -50%);
            width: 8px;
            height: 8px;
            background: #60DEB4;
            border-radius: 56px;

        }
        &.padding_bottom_6{
            padding-bottom: 6px;
        }

        
    }
    .effency_cankao{
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #60DEB4;
        line-height: 20px;
    }

    .effency_desc_first{
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #262633;
        line-height: 24px;
        width: 80px;
        text-align: left;
    }

    .effency_height{
        width: 100px;
        height: 24px;
        background: linear-gradient(90deg, #CAFFF4 0%, #41BBA4 100%);
        margin:0 12px 0 18px;
        max-width: 600px;
        border-radius: 0 24px 24px 0;
    }

    .testresult_vs {
        width: 42px;
        height: 42px;
        background: #D5D5D7;
        display: inline-block;
        border-radius: 50%;
        font-size: 21px;
        font-family: Arial-BoldMT, Arial;
        font-weight: normal;
        color: #FFFFFF;
        line-height: 42px;
        text-align: center;
        vertical-align: middle;
        margin: 104px 30px 0;
    }

    .padding_top_38 {
        padding: 38px 0 22px;
        box-sizing: border-box;
    }

    .result1 {
        padding-left: 16px;
        box-sizing: border-box;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #51515C;
        line-height: 28px;
        text-align: justify;
    }

    .resultNum {
        font-size: 40px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #262633;
        line-height: 40px;
        padding-bottom: 10px;
    }

    .resultdesc {
        padding-top: 10px;
        font-size: 12px;
        font-family: PingFang-SC-Medium, PingFang-SC;
        font-weight: 500;
        color: #51515C;
        line-height: 14px;
        position: relative;


        &:before {
            content: '';
            position: absolute;
            top: 0;
            width: 40px;
            height: 1px;
            background-color: #F4F4F5;
            left: 0;

        }
    }

    .padding_top_28 {
        // padding-top: 28px;
        padding-left: 46px;
        box-sizing: border-box;
    }

    .padding_top_20 {
        // padding-top: 20px;
        padding-right: 20px;
        box-sizing: border-box;
    }

    .padding_right_184 {
        padding-right: 184px;
        box-sizing: border-box;
    }

    .padding_right64 {
        padding-right: 64px;
        box-sizing: border-box;
    }

    .padding_left_42 {
        padding-left: 12px;
        box-sizing: border-box;
    }

    .fishdesc {
        text-align: center;
        font-size: 16px;
        font-family: PingFang-SC-Medium, PingFang-SC;
        font-weight: 500;
        color: #51515C;
        padding-top: 8px;
        box-sizing: border-box;
    }

    .fishimg {
        position: absolute;
        left: 22px;
        top: 50%;
        transform: translate(0, -50%);
    }

    .fishqcround {
        width: 80px;
        height: 80px;
        line-height: 80px;
        text-align: center;
        display: inline-block;
        background-image: url('http://p1.fishqc.net/FjD4dfCGmBJ33_K3UcPUinzSx0De');
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center center;
        // background-color: #53D5C2;
        font-size: 28px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        border-radius: 50%;
        margin-left: 71px;
        padding-left: 6px;
        box-sizing: border-box;

        &.green {
            // background-color: #53D5C2;
        }

        &.yellow {
            // background-color: #FFDB69;
        }

        &.red {
            // background-color:#FF7338;
        }

        &.grave {
            background-image: url('http://p1.fishqc.net/FvyRjPY9ceyjmo3xS6t9e_0Jve2i');
        }

        &.margin_left0 {
            margin-left: 0;
        }
    }

    .desc2 {
        padding-top: 26px;
        box-sizing: border-box;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #51515C;
        line-height: 28px;
        text-align: justify;
    }

    .desc3 {
        padding-top: 24px;
        font-size: 16px;
        font-family: PingFang-SC-Regular, PingFang-SC;
        font-weight: 400;
        color: #51515C;
        line-height: 28px;
        text-align: justify;
    }

    .rankItem {
        .rankItem_productimg {
            width: 148px;
            height: 100%;
            background-image: url('http://p1.fishqc.net/FiVwYzbfQSdgjBZRGyqwknMlLTyb!product.thumb');
            background-size: contain;
            background-position: center center;
            background-repeat: no-repeat;
        }

        .product_title {
            padding-top: 14px;
            box-sizing: border-box;
            font-size: 18px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #353C46;
            line-height: 24px;
        }

        .product_bable {
            margin: 8px 0 0px;
            padding: 6px 16px 6px 4px;
            box-sizing: border-box;
            background-color: #6EDECD;
            font-size: 9px;
            line-height: 9px;
            font-family: PingFangSC-Regular, PingFang SC;
            color: #fff;
            display: inline-block;
            position: relative;

            &:after {
                content: '';
                position: absolute;
                right: -10px;
                top: 0;
                width: 22px;
                height: 21px;
                background-image: url('http://p1.fishqc.net/FujtO5kFbA_ovum4FQIsxSQBvCVN');
                background-size: contain;
                background-position: 0px center;
                background-repeat: no-repeat;
            }
        }

        .productdetail {
            margin: 0px 32px 16px 0;
            box-sizing: border-box;
        }

        .productitemdetail {
            font-size: 12px;

            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #9B9B9B;

            .productitemdetails {
                padding: 6px 0;
                border-bottom: 1px solid #F8F8F8;

                &:last-child {
                    border-bottom: none;
                    padding-bottom: 0;
                }

                .color {
                    color: #333;
                }

                .fix-width-60 {
                    width: 76px;
                    display: inline-block;
                }
            }
        }
    }

    .secondtitle {
        padding: 0 0 10px 16px;
        box-sizing: border-box;
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #262633;
        line-height: 32px;

        &.padding_top_24 {
            padding-top: 24px;
            box-sizing: border-box;
        }
    }
}


.ingredient_reportcontian{
    box-sizing: border-box;
    
    margin-bottom: 64px;
    .report_title {
        font-size: 32px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        line-height: 48px;
    }

    .report_collect {
        display: inline-block;
        width: 64px;
        height: 24px;
        line-height: 24px;
        background: #60DEB4;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        letter-spacing: 3px;
        text-align: center;
    }

    .report_time {
        line-height: 24px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #888888;
        padding-right: 30px;
        box-sizing: border-box;
    }

    .report_desc {
        font-size: 16px;
        font-family: PingFang-SC-Regular, PingFang-SC;
        font-weight: 400;
        color: #51515C;
        line-height: 28px;
        text-align: justify;
    }

    .report_subtitle {
        font-size: 28px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #262633;
        line-height: 32px;
        
        display: inline-block;

        padding-left: 2px;
        box-sizing: border-box;
        font-size: 24px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #424242;
        line-height: 32px;

    }

    .title_box {
        padding-top: 64px;
        box-sizing: border-box;
        .title_line {
            height: 2px;
            background: #F8FBFD;
            position: relative;

            
        }

        .title_right{
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #60DEB4;
            line-height: 16px;
            cursor: pointer;
        }
    }

    .testresult {
        padding: 24px 0 16px 16px;
        box-sizing: border-box;
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        line-height: 32px;
        position: relative;
        text-align: left;
        color: #424242;
        &:before {
            content: '';
            position: absolute;
            left: 0%;
            top: 36px;
           
            width: 8px;
            height: 8px;
            background: #60DEB4;
            border-radius: 56px;

        }
        &.padding_bottom_6{
            padding-bottom: 6px;
        }

        
    }
    .effency_cankao{
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #60DEB4;
        line-height: 20px;
    }

    .effency_desc_first{
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #262633;
        line-height: 24px;
        width: 80px;
        text-align: left;
    }

    .effency_height{
        width: 100px;
        height: 24px;
        background: linear-gradient(90deg, #CAFFF4 0%, #41BBA4 100%);
        margin:0 12px 0 18px;
        max-width: 600px;
        border-radius: 0 24px 24px 0;
    }

    .testresult_vs {
        width: 42px;
        height: 42px;
        background: #D5D5D7;
        display: inline-block;
        border-radius: 50%;
        font-size: 21px;
        font-family: Arial-BoldMT, Arial;
        font-weight: normal;
        color: #FFFFFF;
        line-height: 42px;
        text-align: center;
        vertical-align: middle;
        margin: 104px 30px 0;
    }

    .padding_top_38 {
        padding: 38px 0 22px;
        box-sizing: border-box;
    }

    .result1 {
        padding-left: 16px;
        box-sizing: border-box;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #51515C;
        line-height: 28px;
        text-align: justify;
    }

    .resultNum {
        font-size: 40px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #262633;
        line-height: 40px;
        padding-bottom: 10px;
    }

    .resultdesc {
        padding-top: 10px;
        font-size: 12px;
        font-family: PingFang-SC-Medium, PingFang-SC;
        font-weight: 500;
        color: #51515C;
        line-height: 14px;
        position: relative;


        &:before {
            content: '';
            position: absolute;
            top: 0;
            width: 40px;
            height: 1px;
            background-color: #F4F4F5;
            left: 0;

        }
    }

    .padding_top_28 {
        // padding-top: 28px;
        padding-left: 46px;
        box-sizing: border-box;
    }

    .padding_top_20 {
        // padding-top: 20px;
        padding-right: 20px;
        box-sizing: border-box;
    }

    .padding_right_184 {
        padding-right: 184px;
        box-sizing: border-box;
    }

    .padding_right64 {
        padding-right: 64px;
        box-sizing: border-box;
    }

    .padding_left_42 {
        padding-left: 12px;
        box-sizing: border-box;
    }

    .fishdesc {
        text-align: center;
        font-size: 16px;
        font-family: PingFang-SC-Medium, PingFang-SC;
        font-weight: 500;
        color: #51515C;
        padding-top: 8px;
        box-sizing: border-box;
    }

    .fishimg {
        position: absolute;
        left: 22px;
        top: 50%;
        transform: translate(0, -50%);
    }

    .fishqcround {
        width: 80px;
        height: 80px;
        line-height: 80px;
        text-align: center;
        display: inline-block;
        background-image: url('http://p1.fishqc.net/FjD4dfCGmBJ33_K3UcPUinzSx0De');
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center center;
        // background-color: #53D5C2;
        font-size: 28px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        border-radius: 50%;
        margin-left: 71px;
        padding-left: 6px;
        box-sizing: border-box;

        &.green {
            // background-color: #53D5C2;
        }

        &.yellow {
            // background-color: #FFDB69;
        }

        &.red {
            // background-color:#FF7338;
        }

        &.grave {
            background-image: url('http://p1.fishqc.net/FvyRjPY9ceyjmo3xS6t9e_0Jve2i');
        }

        &.margin_left0 {
            margin-left: 0;
        }
    }

    .desc2 {
        padding-top: 26px;
        box-sizing: border-box;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #51515C;
        line-height: 28px;
        text-align: justify;
    }

    .desc3 {
        padding-top: 24px;
        font-size: 16px;
        font-family: PingFang-SC-Regular, PingFang-SC;
        font-weight: 400;
        color: #51515C;
        line-height: 28px;
        text-align: justify;
    }

    .rankItem {
        .rankItem_productimg {
            width: 148px;
            height: 100%;
            background-image: url('http://p1.fishqc.net/FiVwYzbfQSdgjBZRGyqwknMlLTyb!product.thumb');
            background-size: contain;
            background-position: center center;
            background-repeat: no-repeat;
        }

        .product_title {
            padding-top: 14px;
            box-sizing: border-box;
            font-size: 18px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #353C46;
            line-height: 24px;
        }

        .product_bable {
            margin: 8px 0 0px;
            padding: 6px 16px 6px 4px;
            box-sizing: border-box;
            background-color: #6EDECD;
            font-size: 9px;
            line-height: 9px;
            font-family: PingFangSC-Regular, PingFang SC;
            color: #fff;
            display: inline-block;
            position: relative;

            &:after {
                content: '';
                position: absolute;
                right: -10px;
                top: 0;
                width: 22px;
                height: 21px;
                background-image: url('http://p1.fishqc.net/FujtO5kFbA_ovum4FQIsxSQBvCVN');
                background-size: contain;
                background-position: 0px center;
                background-repeat: no-repeat;
            }
        }

        .productdetail {
            margin: 0px 32px 16px 0;
            box-sizing: border-box;
        }

        .productitemdetail {
            font-size: 12px;

            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #9B9B9B;

            .productitemdetails {
                padding: 6px 0;
                border-bottom: 1px solid #F8F8F8;

                &:last-child {
                    border-bottom: none;
                    padding-bottom: 0;
                }

                .color {
                    color: #333;
                }

                .fix-width-60 {
                    width: 76px;
                    display: inline-block;
                }
            }
        }
    }

    .secondtitle {
        padding: 0 0 10px 16px;
        box-sizing: border-box;
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #262633;
        line-height: 32px;

        &.padding_top_24 {
            padding-top: 24px;
            box-sizing: border-box;
        }
    }
}
.rankItem {
    width: 384px;
    height: 184px;
    margin-top: 24px;
    border: 1px solid #F4F4F5;
    margin-right: 20px;
    cursor: pointer;

    &:nth-of-type(2n) {
        margin-right: 0;
    }
}

.fishblock {
    width: 100%;
    height: 120px;
    background-color: #EBFFFE;
    padding-left: 36px;
    box-sizing: border-box;
    margin-bottom: 24px;
    padding-top: 32px;

    &:nth-of-type(1) {
        margin-top: 32px;
    }

    &.green {
        background: #EBFFFE;
    }

    &.yellow {
        background: #FFFDF1;
    }

    &.red {
        background: #FFF5F1;
    }

    .padding_left_16 {
        padding-left: 16px;
        box-sizing: border-box;
    }

    .title {

        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #53D5C2;
        line-height: 22px;
        padding-bottom: 10px;
        box-sizing: border-box;

        &.yellowcolor {
            color: #FFC72F;
        }

        &.redcolor {
            color: #FF8437;
        }
    }

    .desc {

        font-size: 16px;
        font-family: PingFang-SC-Regular, PingFang-SC;
        font-weight: 400;
        color: #51515C;
        line-height: 16px;
    }


}

.desc4 {
    padding-top: 6px;
    box-sizing: border-box;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #51515C;
    line-height: 28px;
    text-align: justify;
}

.tiaochacontain {
    padding: 0 10px 0 42px;
    box-sizing: border-box;
}

.tiaochaimg {
    padding-top: 24px;
    box-sizing: border-box;
}

.tiaochatxt {
    padding-top: 14px;
    box-sizing: border-box;
    font-size: 16px;
    font-family: PingFang-SC-Regular, PingFang-SC;
    font-weight: 400;
    color: #60DEB4;
    line-height: 24px;
}

.padding_left_16 {
    padding-left: 16px;
    box-sizing: border-box;
}

.desc5 {
    padding: 0 0 16px 0px;
    box-sizing: border-box;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #51515C;
    line-height: 28px;
}

.reportinfo_text {
    width: 278px;
    height: 61px;
    background: #FFFFFF;
    border-radius: 40px;
    border: 1px solid #DBDCDC;
    position: absolute;
    right: -278px;
    bottom: 8px;
    padding: 6px 20px 0 56px;
    box-sizing: border-box;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #262633;
    line-height: 24px;

    .position_left {
        position: absolute;
        left: -36px;
        top: -12px;
    }
}

.reportinfo_img1 {
    width: 484px;
    height: 293px;
    background-color: #eee;

}

.reportinfo_img2 {
    width: 369px;
    height: 200px;
    line-height: 200px;
    background-color: #666;
    text-align: center;
    font-size: 24px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    background-position: center center;
    background-size: cover;
    background-repeat: no-repeat;
}

.reportinfo_img3 {
    width: 238px;
    height: 200px;
    line-height: 200px;
    background-color: #666;
    text-align: center;
    font-size: 24px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    background-position: center center;
    background-size: cover;
    background-repeat: no-repeat;
}

.vs-right-ul_left {
    padding-left: 24px;
    box-sizing: border-box;
}

.vs-right-li {
    height: 32px;
    line-height: 32px;
    background: #F0FFFC;
    border-radius: 16px;
    background-color: #F0FFFC;
    font-size: 16px;
    font-family: PingFang-SC-Regular, PingFang-SC;
    font-weight: 400;
    color: #60DEB4;
    padding: 0 20px 0 30px;
    margin-bottom: 14px;
    display: inline-block;
    position: relative;

    &:before {
        content: '';
        width: 13px;
        height: 13px;
        display: inline-block;
        border-radius: 50%;
        background-color: #60DEB4;
        position: absolute;
        left: 9px;
        top: 10px;
    }

    &.grave {
        color: #A8A8AD;
        background-color: #F4F4F5;
        padding: 0 15px;
        margin-left: 13px;

        &:before {
            content: '';
            width: 13px;
            height: 13px;
            display: inline-block;
            border-radius: 50%;
            background-color: #A8A8AD;
            position: absolute;
            left: -19px;
            top: 10px;
        }
    }
}

.padding_top_24 {
    padding-top: 24px;
    box-sizing: border-box;
}

.desc6 {
    padding: 16px 0;
    box-sizing: border-box;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #262633;
    line-height: 28px;
}

.desc7 {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #51515C;
    line-height: 32px;
    padding-bottom: 22px;
}

.desc8 {
    padding-left: 30px;
    font-size: 16px;
    font-family: PingFang-SC-Regular, PingFang-SC;
    font-weight: 400;
    color: #51515C;
    line-height: 28px;
    text-align: justify;
}

.desc9 {
    padding-bottom: 16px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #51515C;
    line-height: 28px;
    text-align: justify;

    .strong {
        font-weight: bold;
    }
}

.padding_top_32 {
    padding-top: 32px !important;
    box-sizing: border-box;
}

.padding_bottom_30 {
    padding-bottom: 30px;
    box-sizing: border-box;
}

.fishqc_tech_title {
    box-sizing: border-box;
    font-size: 18px;
    font-family: PingFang-SC-Medium, PingFang-SC;
    font-weight: 500;
    color: #262633;
    line-height: 26px;
    width: 260px;
    padding-left: 40px;

    span {
        font-size: 18px;
        font-family: PingFang-SC-Medium, PingFang-SC;
        font-weight: 500;
        color: #262633;
        line-height: 26px;
    }

    &.lie2 {
        width: 240px;
        padding-left: 40px;
        text-align: justify;
    }

    &.lie3 {
        width: 200px;
        padding-left: 40px;
    }

    &.lie4 {}

    &.margin_left_42 {
        margin-left: 42px;
    }

    &.margin_left_50 {
        margin-left: 50px;
    }


}

.height_80 {
    width: 100%;
    height: 80px;
    padding-top: 14px;
    box-sizing: border-box;
    background-color: #F8FBFD;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #51515C;
    line-height: 30px;
}

.height_150 {
    width: 100%;
    height: 150px;
    background-color: #F1FFFA;
    padding-top: 32px;
    box-sizing: border-box;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #51515C;
    line-height: 30px;
}

.height_150_yellow {
    width: 100%;
    height: 150px;
    background-color: #FFFDF1;
    padding-top: 32px;
    box-sizing: border-box;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #51515C;
    line-height: 30px;
}

.height_150_red {
    width: 100%;
    height: 150px;
    background-color: #FFF5F1;
    padding-top: 16px;
    box-sizing: border-box;
}

.collect_btn {
    width: 144px;
    height: 48px;
    background: #FFFFFF;
    border: 1px solid #60DEB4;
    margin: 52px auto 62px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #60DEB4;
    line-height: 48px;
    letter-spacing: 4px;
    padding-left: 66px;
    box-sizing: border-box;
    position: relative;
    cursor: pointer;

    &:before {
        content: '';
        position: absolute;
        left: 38px;
        top: 15px;
        width: 19px;
        height: 18px;
        background: url('http://p1.fishqc.net/FpwPBMetiVz9yF37lsc3VBjuC421') center center no-repeat;
    }
}

.publish {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #888888;
    line-height: 12px;
}

.share {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #888888;
    line-height: 12px;
}

// 详情页
.productdetail_type {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #888888;
    line-height: 12px;
    padding: 24px 0 26px;
    box-sizing: border-box;
    text-align: left;
}

.productImage {
    width: 378px;
    height: 378px;
    border: 1px solid #F4F4F5;
    // background: url('http://p1.fishqc.net/FiYvORyEWsDqy7MD59eFEjow9OuD!product.thumb') center center no-repeat;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    cursor: pointer;
    position: relative;

/*background-color: #F8FBFD;*/
}

.fishqc_try {
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #262633;
    line-height: 20px;
    text-align: left;
    padding: 26px 0 16px;
    box-sizing: border-box;
}

.try_detailbox {
    width: 100%;
    height:48px;
    line-height: 48px;
    
    background: #FFF0EA;
    position: absolute;
    bottom: 0;
}

.product_detail_contain {
    /*width: 690px;*/
    margin-left: 24px;
    text-align: left;

    .product_subtitle {
        font-size: 24px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        line-height: 34px;
    }

    .product_tips {
        padding: 0 16px;
        box-sizing: border-box;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #3AD6A2;
        line-height: 24px;
        height: 24px;
        /*background: linear-gradient(270deg, #28D877 0%, #0DC6B8 100%);*/
        background: #EAFFF9;
        border-radius: 0px 12px 12px 12px;
        display: inline-block;
        margin-right: 16px;

        &:nth-of-type(1) {
            margin-left: 0;
        }

    }

    .product_effency_tips {
        padding: 0 20px 0 20px;
        box-sizing: border-box;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        line-height: 24px;
        height: 24px;
        background-color: #43A0AC;
        background-image: url('http://p1.fishqc.net/FujtO5kFbA_ovum4FQIsxSQBvCVN');
        background-repeat: no-repeat;
        background-position: right center;
        background-size: contain;
        border-radius: 0px 12px 12px 12px;
        display: inline-block;
        background: #E9FDFE;
        color: #3AC7CE;

        border-radius: 0px 12px 12px 12px;
    }

    .product_effect_box {
        padding: 20px 0 20px 28px;
        box-sizing: border-box;
        background: #F8FBFD;
        border-radius: 0px 24px 24px 24px;

        img {
            margin-left: 16px;

            &:nth-of-type(1) {
                margin-left: 0px;
            }
        }

        .product_effect_desc {
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #262633;
            line-height: 28px;
            padding: 0 38px 0 26px;
            box-sizing: border-box;
        }

    }

    .product_detail_info {
        padding: 42px 0 4px;
        box-sizing: border-box;
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #262633;
        line-height: 20px;
    }

    .product_detail_infobox {
        width: 380px;

        .product_detail_infolist {
            width: 100%;
            line-height: 50px;
            border-bottom: 2px solid rgba(190, 190, 190, 0.15);

            .product_detail_infolistL {
                width: 82px;
                height: 22px;
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #9B9B9B;
                line-height: 26px;
                display: inline-block;
            }

            .product_detail_infolistR {
                padding-left: 30px;
                box-sizing: border-box;
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #262633;
                line-height: 14px;
            }
        }

        
    }

}

.padding__top_8 {
    padding-top: 8px;
    box-sizing: border-box;
    padding-bottom: 16px;
}

.padding_top_34 {
    padding-top: 34px;
    padding-bottom: 64px;
    box-sizing: border-box;
}

.padding_top_26 {
    padding-top: 26px;
    box-sizing: border-box;
}

.product_detail_effectdetail {
    width: 248px;
    height: 200px;
    background: #F8FBFD;
    text-align: center;
}

.product_detail_suggest {
    width: 360px;
    padding:26px 20px;
    box-sizing: border-box;
    border: 1px solid #F4F4F5;
    .productbox{
        width: 100%;
        height: 320px;
        background: #FFFFFF;
        border: 1px solid #F4F4F5;
        box-sizing: border-box;
        margin:32px 0 12px;
        position: relative;

        .productimg{
            width:240px;
            height: 240px;
            box-sizing: border-box;
            background-repeat: no-repeat;
            background-position: center center;
            background-size: contain;
            position: absolute;
            left:50%;
            top:50%;
            transform: translate(-50%,-50%);
        }
        .labelImg{
            position: absolute;
            top: 16px;
            left: 14px;
            text-align: left;
        }
    }

    .productname{
        text-align: left;
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333342;
        line-height: 28px;
        @include linelimt(2);
    }

    .live{
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 24px;
        text-align: left;
        padding-bottom: 16px;
        border-bottom: 2px solid #F4F4F5;
    }

}

.img1 {
    width: 95px;
    height: 95px;
    margin: 0 auto;
    display: block;
    margin-bottom: 12px;
}

.width-100 {
    width: 100%;
}

.product_detail_effecttxt {
    font-size: 20px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #262633;
    line-height: 32px;
    position: relative;
    width: 100%;

    .product_detail_effecttxtbg {
        width: 160px;
        height: 8px;
        background-color: #60DEB4;
        margin: 0 auto;
        position: absolute;
        bottom: -26px;
        left: 50%;
        transform: translate(-50%, 0);
    }

    .effectresult {
        position: absolute;
        width: 100%;
        display: block;
    }

}

.productdetail_test {
    font-size: 20px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #262633;
    line-height: 32px;
    padding: 24px 0 16px;
    box-sizing: border-box;
}

.productdetail_test1 {
    width: 100%;
    // height: 240px;
    background: #FFFFFF;
    border: 2px solid #F4F4F5;
    margin-bottom: 24px;
    padding-bottom: 20px;
    box-sizing: border-box;
    .productdetail_test_desc {
        text-align: center;
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #262633;
        line-height: 24px;
        padding-top: 18px;
        box-sizing: border-box;
    }

    .productdetail_test_desc1 {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #51515C;
        line-height: 24px;
        text-align: center;
        padding: 0 40px;
        box-sizing: border-box;
    }

    .padding_top_16 {
        padding-top: 16px;
        box-sizing: border-box;
    }

    .product_img {
        width: 152px;
        height: 152px;
        background-position: center center;
        background-repeat: no-repeat;
        background-size: contain;

        margin-left: 20px;
    }
}

.effect_detail {
    padding: 24px 0;
    box-sizing: border-box;
    font-size: 20px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #262633;
    line-height: 32px;

    .color1 {
        color: #43A0AC;
        padding: 0 6px;
        box-sizing: border-box;
    }
}
.effecttype {
        position: absolute;
        width: 78px;
        height: 24px;
        line-height: 24px;
        background: #43A0AC;
        border-radius: 0px 0px 16px 0px;
        text-align: center;
        left: 0;
        top: 0;
        color: #fff;
    }
.effect_item {
    width: 100%;
    // min-height: 184px;
    background-color: #F8FBFD;
    /*margin-bottom: 24px;*/
    padding: 0 38px 0 46px;
    box-sizing: border-box;
    position: relative;

    

    .effecttitle {
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #262633;
        line-height: 20px;
    }

    .effextdesc {
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #51515C;
        line-height: 28px;
        text-align: justify;
        padding-top: 10px;
        box-sizing: border-box;
        width: 550px;
    }
}

.try_padding_top_30 {
    padding: 30px 0 34px;
    box-sizing: border-box;
}

.product_try_totaldesc {

    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #262633;
    line-height: 20px;
    letter-spacing: 2px;
}

.product_try_totalnum {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #60DEB4;
    line-height: 20px;
}

.try_star {
    width: 24px;
    height: 24px;
    margin-right: 12px;
}

.paddding_top_10 {
    padding: 10px 0 22px;
    box-sizing: border-box;
    border-bottom: 1px solid #F4F4F5;

}

.try_tips {
    height: 32px;
    border: 1px solid #60DEB4;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #60DEB4;
    line-height: 32px;
    padding: 0 12px;
    box-sizing: border-box;
    display: inline-block;
    margin-right: 16px;
}

.try_box {
    padding: 24px 0 36px 10px;
    box-sizing: border-box;
}

.try_commentImg {
    width: 50px;
    height: 50px;
    border-radius: 50%;

    background-color: #eee;
}

.nickname {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #262633;
    line-height: 20px;
    padding-left: 24px;
}

.suggest {
    padding-left: 24px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #A8A8AD;
    line-height: 20px;
}

.padding_left_90 {
    padding-left: 76px;
    box-sizing: border-box;

    .title {
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #262633;
        line-height: 23px;
        padding: 10px 0 0px;
        box-sizing: border-box;
    }

    .content {
        text-align: justify;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #51515C;
        line-height: 28px;
    }

    .maxwidth {
        width: 550px;
    }

    .contentImg {
        margin: 16px 16px 0 0;
        width: 160px;
        height: 160px;
        background: #60DEB4;
        display: inline-block;
    }

    .contentdetail {
        font-size: 12px;
        font-family: STHeitiSC-Light, STHeitiSC;
        font-weight: 300;
        color: #51515C;
        line-height: 12px;
        padding-top: 30px;

        .padding_right_20 {
            padding-right: 20px;
            box-sizing: border-box;
        }
    }

    .content_suggest_box {
        height: 24px;
        line-height: 24px;
        background: #F8FBFD;
        border-radius: 0px 100px 100px 0px;
        display: inline-block;
        padding: 0 14px 0 0;
        margin: 16px 0;
        box-sizing: border-box;
    }

    .content_question{
        height: 100%;

        background: linear-gradient(270deg, #28D877 0%, #0DC6B8 100%);
        border-radius: 0px 100px 100px 0px;
        border: 2px solid #FFFFFF;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 24px;
        padding:0 10px;
        box-sizing: border-box;
        margin-right: 14px;
    }
}

.margin_top_12 {
    margin-top: 12px;
}

.padding_14_10 {
    padding: 0 10px 0 14px;
    box-sizing: border-box;
}

.padding_right_30 {
    padding-right: 30px;
    box-sizing: border-box;
}

.productdetail_test_result {
    padding-top: 12px;
    box-sizing: border-box;
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #262633;
    line-height: 24px;
}

.effency_margin{
    margin-top: 16px;
}

.suggesttitle {
    font-size: 32px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #262633;
    line-height: 32px;
    text-align: left;
    padding-top: 40px;
    padding-bottom: 32px;
    margin-bottom: 32px;
    border-bottom: 2px solid #F8FBFD;

}
.more {
    width: 246px;
    height: 48px;
    text-align: center;
    line-height: 48px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #51515C;
    letter-spacing: 4px;
    cursor: pointer;
    background: url('../../assets/images/arr.png') no-repeat 210px 20px;
    background-color: #FFFFFF;
    &.border{
        border: 1px solid #E9E9EB;
    }
    &:hover{
        color: #fff;
        background: url('https://p1.fishqc.net/FlRbIiMKiKzC7ci97sZYFJ284KUS') no-repeat 210px 20px;
        background-color: #60DEB4;
    }
}

.product_detail_icon{
    width: 130px;
    height: 130px;
}
.product_detail_icon1{
    width: 60px;
    height: 60px;
}

.Freebtn{
    width: 180px;
    
background: #FFDACB;
    color: #FF7338;
}

.right_lefttime{
    
color: #FF7338;
    height: 48px;
    background: #FFF0EA;
}

.price_linethrough{
    text-decoration: line-through;
}

.product_parameter{
    width: 590px;
    height: 128px;
    padding: 22px 32px 25px 25px;
    box-sizing: border-box;
    background-color: #F8FBFD;
    display: inline-block;
    margin-bottom: 10px;

}

.product_parameter_item{
    width: 250px;
    /*height: 1px;*/
    border-bottom: 1px solid rgba(190,190,190,.1);
    padding-bottom: 12px;
    box-sizing: border-box;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #9B9B9B;
    position: relative;

}

.product_parameter_name{
    font-size: 12px;
font-family: PingFangSC-Regular, PingFang SC;
font-weight: 400;
color: #9B9B9B;
line-height: 18px;

}

.product_parameter_conent{
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #424242;
    line-height: 18px;
    position: absolute;
    left: 80px;
    margin-left: 15px;
}

.efficacyimg{
    width: 100px;
    width: 100px;
}

.product_detail_collectbtn {
    width: 144px;
    height: 48px;
    line-height: 48px;
    background: #FFFFFF;
    border: 1px solid #60DEB4;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #60DEB4;
    letter-spacing: 4px;
    position: relative;
    padding-left: 66px;
    box-sizing: border-box;
    cursor: pointer;
    background-color: rgba(234, 255, 249, 1);
    margin-right: 16px;
    // &:before {
    //     content: '';
    //     position: absolute;
    //     left: 38px;
    //     top: 16px;
    //     width: 16px;
    //     height: 15px;
    //     background: url('http://p1.fishqc.net/FpwPBMetiVz9yF37lsc3VBjuC421') center center no-repeat;
    //     background-size: contain;
    // }
    &:before{
        content:'';
        position: absolute;
        left: 38px;
        top:50%;
        transform:translate(0,-50%);
        width:16px;
        height: 16px;
        background-image: url('http://p1.fishqc.net/Flc4z_hWNfyrvJfg1gMSux-xxqAG');
        background-repeat: no-repeat;
        background-position: center center;
        background-size: contain;
   }
   &.active{
        &:before{
            content:'';
            position: absolute;
            left: 38px;
            top:50%;
            transform:translate(0,-50%);
            width:16px;
            height: 16px;
            background-image: url('http://p1.fishqc.net/FoKkNmGg00gPWcvsodcw43dcIc6n');
            background-repeat: no-repeat;
            background-position: center center;
            background-size: contain;
       }
   }
}

.product_detail_aboutreport {
    width: 200px;
    height: 48px;
    background: #60DEB4;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 48px;
    letter-spacing: 4px;
    padding-left: 68px;
    box-sizing: border-box;
    cursor: pointer;
    position: relative;

}

.detail_introduct_title{
    padding: 64px 0 24px;
    box-sizing: border-box;
    text-align: left;
    font-size: 24px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #424242;
    line-height: 32px;
}

.detail_introduct_productImg{
    width: 160px;
    height: 160px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
}

.detail_introduct_productdesc{
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FF7338;
    line-height: 24px;
    padding-top: 16px;
    box-sizing: border-box;
}

.detail_introduct_effencytitle{
    width: 260px;
    font-size: 20px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #424242;
    line-height: 24px;
    text-align: left;
    padding-bottom: 14px;
    box-sizing: border-box;
}
.detail_introduct_effencydesc{
    width: 260px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #888888;
    line-height: 24px;
    text-align: left;
}

.detail_effency_title{
    font-size: 24px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #424242;
    line-height: 32px;
    padding: 64px 0 16px;
    box-sizing: border-box;
    text-align: left;
}

.detail_effency_xiang{
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #424242;
    line-height: 32px;
    text-align: left;
    padding-bottom: 36px;
    box-sizing: border-box;
}

.detail_effency_Image{
    width: 120px;
    height: 120px;
    
    margin-right: 12px;
    position: relative;
    .bg{
        width: 100%;
        height: 100%;
        background: #F4F4F5;
        filter: blur(4px);
        border-radius: 50%;
        position: absolute;
        left: 0;
    }
}

.detail_effency_effecttitle{
    font-size: 20px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 20px;
    padding-bottom: 16px;
    box-sizing: border-box;
    text-align: left;
}
.detail_effency_effextdesc{
    width: 894px;
    font-size: 16px;
    font-family: PingFang-SC-Regular, PingFang-SC;
    font-weight: 400;
    color: #888888;
    line-height: 28px;
    text-align: left;
}

.guss_love{
    font-size: 24px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #424242;
    line-height: 32px;
    padding: 64px 0 24px;
    box-sizing: border-box;
    text-align: left;
}
.detail_bgColor{
    background: #fff;
    &:nth-child(even){
        background: #F8FBFD;
    }
}

.margin_left_16{
    margin-left: -16px;
    &.active{
        margin-left: 0px;
    }
    
}
.green_bg{
    width: 100%;
    /*height: 210px;*/
    background: url('https://p1.fishqc.net/Fg9v4LONhGhzaMkzVhdc9OZoVauN') center center no-repeat;
    background-size: cover;
    padding: 30px 0;
    box-sizing: border-box;
    margin-bottom: 24px;
    .greenbg_content{
        width: 1009px;
        /*height: 150px;*/
        
        border-radius: 100px;
        
        margin: 0px auto;
        position: relative;
        .left0{
            position: absolute;
            left: 0;
            .greenicon{
                width: 150px;
                height: 150px;
            }
        }
    }
    .bgcolor{
        background: #F8FBFD;
        border-radius: 100px;
        opacity: 0.9;
        padding-left: 150px;
        padding-right: 74px;
        box-sizing: border-box;
        text-align: left;
        padding: 18px 74px 18px 150px;
        .padding_left24{
            padding-left: 24px;
            box-sizing: border-box;
        }
        .greenfish_title{
            font-size: 20px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
            line-height: 32px;
            &.engsize{
                font-size: 16px;
                line-height: 26px;
            }
        }
        .greenfish_desc1,.greenfish_desc2{
            font-size: 16px;
            font-family: PingFang-SC-Regular, PingFang-SC;
            font-weight: 400;
            color: #333333;
            line-height: 28px;
            &.engsize{
                font-size: 12px;
                line-height: 22px;
            }
        }
    }
}
</style>
<style type="text/css" lang="scss">
/* 轮播图 */
.swiper-container {
    width: 100%;
    height: 100%;
}

// .swiper-wrapper{
//  height: 430px;
// }
.swiper-slide {
    background-position: center;
    background-size: cover;

}

.index-swpier {
    .swiper-pagination-bullet {
        width: 8px;
        height: 8px;
        background: #E5E5E5;
        border-radius: 4px;

        &.swiper-pagination-bullet-active {
            width: 16px;
            height: 8px;
            background: #76E2D2;
            border-radius: 4px;
        }
    }

    .swiper-pagination-fraction,
    .swiper-pagination-custom,
    .swiper-container-horizontal>.swiper-pagination-bullets {
        text-align: center;
    }
}
</style>
<script>
import Vue from 'vue'
// @ is an alias to /src
import banner from '@/components/banner.vue'
import { productdetailApi,suggestproductApi,suggestrankApi,suggestreportApi,collectApi,productandTryapi,prdTotalTryReportInfoApi} from '@/api/api.js'
import { myMixin } from '@/mixin/mixin.js'
import PicZoom from 'vue-piczoom'
import {formatTime,formatSeconds} from '@/utils/other.js'
import { getCookie } from '@/utils/cookieUtil'
import Modal from '@/components/Modal.vue'
import star from '@/components/star.vue'
export default {
    name: '',
    components: {
        banner,
        PicZoom,
        modal:Modal,
        star:star,

    },
    mixins: [myMixin],
    data() {
        return {
            // 数据
            productdetail:{           //产品详情
                effencyobject:{
                },
                bigimage:''
            },
            effencyresult:[],       
            effencydesc:'',
            effencydescinfo:[],
            securitydata:[],         //风险参考
            compositiondata:[],      //功效
            suggestproductdata:[],   //推荐产品
            suggestreportdata:[],    //推荐报告
            suggestrankdata:[],       //推荐榜单
            swiperOptions1: {   //榜单轮播
                pagination: {
                    el: '.swiper-pagination1'
                },
                // slidesPerGroup : 3,
                slidesPerView : 4,
                uniqueNavElements: false,
                autoplay:true,
                // Some Swiper option/callback...
            },
            swiperOptions2: {  //报告轮播
                pagination: {
                    el: '.swiper-pagination2'
                },
                // slidesPerGroup : 4,
                // slidesPerGroup : 1,
                // slidesPerView : 4,
                autoplay:true,
                uniqueNavElements: false,
                collectflag:false
            },
            swiperOptions3: {  //报告轮播
                pagination: {
                    el: '.swiper-pagination3'
                },
                slidesPerGroup : 3,
                slidesPerView : 4,
                autoplay:true,
                uniqueNavElements: false,
                collectflag:false
            },
            productType:{
                'food':'食品',
                'cosmetic':'美妆及个护',
                
            },
            trydata:{
                trystatus:false
            },
            currentlang:'',
            // 功效
            effencydata:{
                efficacyAntiacne:this.$t('common.effency_type1'),
                efficacyAntiaging:this.$t('common.effency_type2'),
                efficacyRepair:this.$t('common.effency_type3'),
                efficacyWhitening:this.$t('common.effency_type4'),
                efficacyMoisturizing:this.$t('common.effency_type5'),
            },
            langdesc:{
                bought:this.$t('rankindex.bought'),
                free:this.$t('index.free')
            },
            prdId:'',
            productTryReportdata:{},
            productTryReportstatus:false
        }
    },
    computed: {
        swiper() {
            return this.$refs.mySwiper1.$swiper
        },
        splitfun(){
            return function(str){
                return str.split(',')
                
            }
        },
        formatTimefun(){
            return function(ctime){
                return formatTime(ctime,'Y-M-D')
            }
        },
        effencydescNew(){
            var  efficacy = [] ;
            var efficacy1 ;
            return function(obj){
                if(obj && obj.length >0){
                    if(this.currentlang == 'chs'){
                        efficacy1 = ''
                        for(var i=0;i<obj.length;i++){
                            efficacy.push(obj[i].chs_tag_name.split('效果显著')['0'])
                        }
                        var  a1 = this.unique(efficacy)
                        efficacy1 = a1.join('、') 
                        return efficacy1
                    }

                    if(this.currentlang == 'cht'){
                        efficacy1 = ''
                        for(var i=0;i<obj.length;i++){
                            efficacy.push(obj[i].cht_tag_name.split('效果顯著')['0'])
                        }
                        var  a1 = this.unique(efficacy)
                        efficacy1 = a1.join('、') 
                        return efficacy1
                    }

                    if(this.currentlang == 'eng'){
                        efficacy1 = ''
                        for(var i=0;i<obj.length;i++){
                            efficacy.push(obj[i].eng_tag_name.split('Significant Efficacy')['0'])
                        }
                        var  a1 = this.unique(efficacy)
                        efficacy1 = a1.join('、') 
                        return efficacy1
                    }
                    

                    console.log('这里',efficacy1)
                    
                }
                
            }
        },
        // 秒数转格式
        lefttimefun(){
            return function(lefttime){
                return formatSeconds(lefttime)
            }
        },
        effencyTopIcon(){
            return function(effencyarr){
                if(effencyarr!=null && effencyarr.length >0){
                   var arr = {}
                    for(var i=0;i<effencyarr.length;i++){
                        var item = effencyarr[i]
                        arr[item.chs_tag_name] = item
                    }
                    return Object.values(arr) 
                }
                
                
            }
        }
        
    },
    watch:{
        
        '$route' (to, from) {
            console.log(to)
            console.log(from)
            this.$router.go(0)
            //this.$forceUpdate()
        },
    },
    mounted() {
        this.currentlang  = window.localStorage.getItem("LOCALE") ||  'chs'
        this.prdId = this.$route.params.id
        console.log('!!!!!!!!!!!!!!',this.prdId)
        // this.scrollToY(0, 0, 'easeInOutQuint');
        this.getdetail()
        this.suggestproduct()
        this.suggestrank()
        this.suggestreport()
        this.trydetail()
        this.getproductTryReport()
    },
    methods: {
        unique(arr){
         //Set数据结构，它类似于数组，其成员的值都是唯一的
            return Array.from(new Set(arr)); // 利用Array.from将Set结构转换成数组
        },
        getdetail(){
            productdetailApi({
                productType:this.$route.params.type,
                productId:this.$route.params.id,
                lang:window.localStorage.getItem("LOCALE") ||  'chs'
            }).then(res => {
                if (res.code == 200) {
                    console.log(res.data)
                    this.productdetail = res.data
                    this.productdetail.bigimage = this.productdetail.image.split('!')[0]
                    this.productdetail.effencyobject = {
                        'efficacyAntiacne': this.productdetail.efficacyAntiacne,
                        'efficacyAntiaging':this.productdetail.efficacyAntiaging,
                        'efficacyMoisturizing':this.productdetail.efficacyMoisturizing,
                        'efficacyRepair':this.productdetail.efficacyRepair,
                        'efficacyWhitening':this.productdetail.efficacyWhitening
                    }
                        
                    for(let key in this.effencydata){
                         // console.log(key + '---' + effectChart[key]);
                        if(this.productdetail.effencyobject[key] == '1'){
                           this.effencyresult.push(this.effencydata[key])
                           this.effencydescinfo.push({
                                name:this.effencydata[key],
                                desc:this.descinfo[this.effencydata[key]]

                           })
                        }
                    }

                    console.log(this.effencydescinfo)

                    // this.effencydesc = this.effencyresult.join('、')

                    this.productdetail.tag = '护肤'
                    this.ingredientEfficacy = this.productdetail.ingredientEfficacy

                    // 
                    
                    var _ingredientRefer = this.productdetail.ingredientRefer;
                    console.log('成分统计',_ingredientRefer);
                
                    if(_ingredientRefer){
                        // 风险参考成分
                        var safeChart = {
                            'essence' : '香精',
                            'risk' : '风险成分',
                            'antiseptic' : '防腐剂',
                            'pregnant' : '孕妇慎用',
                            'others' : '其它成分'
                        }
                        
                        // 功效参考成分
                        // ingredientEfficacy  0无功效 1清洁类 2防晒类 3通用类
                        var compositionChart = {
                            1:{
                                'clean' : '清洁',
                                'glutamate' : '氨基酸表活',
                                'laurylsulfate' : 'SIS/SLES',
                            },
                            2:{
                                'physicsSunscreen' : '物理防晒',
                                'chemicalSunscreen' : '化学防晒',
                            },
                            3:{
                                'moisturize' : '保湿',
                                'oilcontrol' : '控油',
                                'antioxidant' : '抗氧化',
                                'whitening' : '美白',
                                'relieve' : '舒缓'
                            }
                        }
                        
                        for(let key in safeChart){
                                // console.log(key + '---' + safeChart[key])
                                if(_ingredientRefer[key] > 0){
                                    this.securitydata.push({
                                        key: key,
                                        name: safeChart[key],
                                        num: _ingredientRefer[key]
                                    })
                                }
                        }
                        console.log('securitydata',this.securitydata)
                        console.log('调试%%%%%%',this.ingredientEfficacy)
                        if(this.ingredientEfficacy>0){
                            
                            var _compositionChart = compositionChart[this.ingredientEfficacy];
                            console.log('_compositionChart',_compositionChart)
                            for(let key in _compositionChart){
                                    // console.log(key + '---' + _compositionChart[key])
                                    if(_ingredientRefer[key] > 0){
                                        this.compositiondata.push({
                                            key: key,
                                            name: _compositionChart[key],
                                            num: _ingredientRefer[key]
                                        })
                                    }
                            }
                        }
                        
                        console.log('compositiondata',this.compositiondata)

                        
                    }
        
                }else if(res.code == 400){
                    this.$router.push({
                        path: '/Page404'
                    })
                } else {
                    this.toast(res.message)
                    

                }
            })
        },
        // 推荐的产品
        suggestproduct(){
            suggestproductApi({
                lang:window.localStorage.getItem("LOCALE") ||  'chs',
                limit:12
            }).then(res => {
                if (res.code == 200) {
                    console.log(res.data)
                    this.suggestproductdata = res.data.list 
                }
            })
        },
        // 推荐的榜单
        suggestrank(){
            suggestrankApi({
                lang:window.localStorage.getItem("LOCALE") ||  'chs',
                limit:12,
                device:1
            }).then(res => {
                if (res.code == 200) {
                    console.log(res.data)
                    this.suggestrankdata = res.data.list 
                }
            })
        },
        // 推荐的报告
        suggestreport(){
            suggestreportApi({
                lang:window.localStorage.getItem("LOCALE") ||  'chs',
                limit:9,
                device:1
            }).then(res => {
                if (res.code == 200) {
                    console.log(res.data)
                    this.suggestreportdata = res.data.list 
                }
            }) 
        },
        // 收藏
        collect(){
            var  that = this
            if(that.collectflag){
                return
            }
            this.collectflag = true
            collectApi({
                id:this.$route.params.id,
                type:this.collecttype[this.$route.params.type]
            }).then(res => {
                that.collectflag = false
                if (res.code == 200) {
                    if(that.productdetail.favstatus){
                        this.toast('取消收藏！')
                        that.productdetail.favstatus = false
                        this.$forceUpdate()
                    }else {
                        that.productdetail.favstatus = true
                        this.toast('收藏成功！')
                        this.$forceUpdate()
                    }
                   
                }else if(res.code == 401){
                    this.toast('请登录后再收藏！')
                }else {
                    this.toast(res.message)
                }
            })
        },
        trydetail(){
            productandTryapi({
                prdId:this.$route.params.id,
                prdType:this.$route.params.type
            }).then(res => {
                console.log(res)
                this.trydata.trystatus = false
                if (res.code == 200) {
                    console.log(res.data)
                    this.trydata = res.data
                    console.log('打印trydata')
                    console.log(this.trydata)
                    this.trydata['trystatus'] = true
                    
                }else{
                    this.trydata['trystatus'] = false
                    // this.trydata.trystatus = false
                }
            })
        },
        toproductdetail(item) {
            this.$router.push({
                path: '/product/'+item.productType+'/'+item.productId
            })
        },
        todetail(type,item){
            // if(item.buyStatus){
            //     this.toast('请勿重复购买！')
            //     return
            // }
            switch(type){
                case  'report':
                    if(item.buyStatus){  //已购买状态，进入详情
                        this.gorouter('/report/detail/'+item.reportUnionId)
                    }else{   //弹出导购弹窗，有previewVideo，弹窗视频导购，否则图片导购
                        this.ismodalshow = true
                        this.$refs.modaltoast.show({
                            type:'guide',  //弹窗类型，guide:导购页
                            itemtype:'2',    //报告
                            itemdata:item
                        });
                    }
                break;
                case  'rank':
                    // if(item.buyStatus){  //已购买榜单，进入详情
                    //     this.gorouter('/rank/detail/'+item.rankingUnionId)
                    // }else{
                    //     this.ismodalshow = true
                    //     this.$refs.modaltoast.show({
                    //         type:'guide',
                    //         itemtype:'1',    //榜单
                    //         itemdata:item
                    //     });
                    // }
                    if(getCookie('fqcU')){
                        if(item.buyStatus){  //已购买榜单，进入详情
                            if(item.rankingType == '3'){
                                if(item.urlPc){
                                    window.location.href = item.urlPc
                                }
                            }else{
                                this.gorouter('/rank/detail/'+item.rankingUnionId)
                            }
                        }else{
                            this.ismodalshow = true
                            this.$refs.modaltoast.show({
                                type:'guide',
                                itemtype:'1',    //榜单
                                itemdata:item
                            });
                        }
                    }else{ //未登录
                        if(item.rankingType == '3'){ //专题榜单
                            if(item.urlPc){
                                window.location.href = item.urlPc
                            }
                        }else{   // 非专题榜单

                            if(item.buyStatus){  //已购买榜单，进入详情
                                this.gorouter('/rank/detail/'+item.rankingUnionId)
                            }else{
                                this.ismodalshow = true
                                this.$refs.modaltoast.show({
                                    type:'guide',
                                    itemtype:'1',    //榜单
                                    itemdata:item
                                });
                            }
                        }
                    }
                break;
            }
        },
        getmaterial(e){
            console.log('回调弹窗关闭状态',e)
            this.ismodalshow = e.showstatus
        },
        showBigImg(img){
            this.ismodalshow = true
            this.$refs.modaltoast.show({
                type:'bigImg',  //弹窗类型， 展示大图
                itemdata:{
                    image:img
                }
            });
        },
        //跳转到成分
        checkIngredient: function(choosedItem){
            
            window.localStorage.setItem('compositiondata',JSON.stringify(this.compositiondata))
            window.localStorage.setItem('securitydata',JSON.stringify(this.securitydata))
            window.localStorage.setItem('choosedItem',JSON.stringify(choosedItem))
            
            // window.location.href = '/product/ingredientlist?prdId='+this.prdId+'&efficacy='+this.ingredientEfficacy;
            window.open('/pingredientlist?prdId='+this.prdId+'&efficacy='+this.ingredientEfficacy);
            
        },
        toasttry(item){
            console.log(item)
            // 触发放心试弹窗
            this.$refs.modaltoast.show({
                type:'try',
                try_url:'https://try.fishqc.com/detail/'+item.eid+'?id='+item.eid
            });
        },
        // 产品详情获取试货报告列表
        getproductTryReport(){
            prdTotalTryReportInfoApi({
                lang:window.localStorage.getItem("LOCALE") ||  'chs',
                prdId:this.$route.params.id,
                prdType:this.$route.params.type
            }).then(res => {
                if (res.code == 200) {
                    console.log(res.data)
                    this.productTryReportstatus = true
                    this.productTryReportdata = res.data 
                }else if(res.code == 204){ //无纪录
                    this.productTryReportstatus = false
                }
            }) 
        },
    }
}
</script>